import { render, staticRenderFns } from "./updateUserDataWise.vue?vue&type=template&id=7727e074&scoped=true&"
import script from "./updateUserDataWise.vue?vue&type=script&lang=js&"
export * from "./updateUserDataWise.vue?vue&type=script&lang=js&"
import style0 from "./updateUserDataWise.vue?vue&type=style&index=0&id=7727e074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7727e074",
  null
  
)

export default component.exports